import $ from 'jquery';
import React from 'react';
import { CSVLink } from 'react-csv';
import ReactModal from 'react-modal';
import { string, number, bool, arrayOf, oneOfType } from 'prop-types';
import createHistory from 'history/createBrowserHistory';
import { getQueryParams } from 'utils/query-param-helpers';
import { attachEnterAsClickDecorator } from 'utils/attachEnterAsClick';
import scrollTo from 'utils/scroll-to';
import Loader from '../loader';
import { initActiveFilters, manageActiveFilters, removeActiveFilterGroup, getActiveFiltersWithValues } from './utils/active-filters';
import { parseQueryString, buildQueryString } from './utils/query-string';
import FiltersSection from './filters/';
import ListingItemsSection from './items/';
import { filterItems, paginateItems, sortItems } from './utils/item-filter';
import ModalHelper from './modal/modalHelpers';
import FilteredListingHeader from './filtered-listing-header';
import { dateToString } from './utils/dates';
import ModalCloseConfirmation from './modal/ModalCloseConfirmation';
import * as FilterTypeConstants from './constants/filter-types';

export default class FilteredListing extends React.Component {
    constructor(props) {
        super(props);

        this.history = createHistory();
        ReactModal.setAppElement('.listing-app');
        const propsState = this.getInitialStateFromProps();
        this.state = {
            edocketID: '',
            isLoading: true,
            isDataLoading: false,
            data: {
                contentData: [],
                resources: [],
                filterOptions: []
            },
            APIStatus: '',
            APIMessage: '',
            activeFilters: [],
            currentSort: 'default',
            currentPage: 0, // page 1 is 0 (array index value)
            minDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).getTime(),
            maxDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).getTime(),
            showModal: false,
            modalEdocket: null,
            modalType: '',
            modalMessage: '',
            startDate: '',
            endDate: '',
            exportQuery: '',
            csvData: [],
            unactionedDocketCount: 0,
            unactionedFilterModel: [],
            unactionedList: false,
            modalContentDirty: false,
            showModalCloseConfirmation: false,
            exportCombineLoads: true,
            searchFieldValue: '',
            isFilterDirty: false,
            isDateDirty: false,
            lastStartDate: '',
            lastEndDate: '',
            ...propsState
        };

        this.toggleFilters = this.toggleFilters.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        this.resetFilterGroup = this.resetFilterGroup.bind(this);
        this.changePage = this.changePage.bind(this);
        this.updateSort = this.updateSort.bind(this);
        this.toggleFocus = this.toggleFocus.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.fetchDataByNo = this.fetchDataByNo.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.doExport = this.doExport.bind(this);
        this.interval = '';
        this.fetchUnactionedDockets = this.fetchUnactionedDockets.bind(this);
        this.clearUnactionedDockets = this.clearUnactionedDockets.bind(this);
        this.fetchFilters = this.fetchFilters.bind(this);
        this.triggerFetchData = this.triggerFetchData.bind(this);
        this.handleFetchingError = this.handleFetchingError.bind(this);
        this.updateContentDirty = this.updateContentDirty.bind(this);
        this.closeConfirmationConfirmHandler = this.closeConfirmationConfirmHandler.bind(this);
        this.closeConfirmationCancelHandler = this.closeConfirmationCancelHandler.bind(this);
        this.toggleExportCombineLoads = this.toggleExportCombineLoads.bind(this);
        this.updateSearchFieldValue = this.updateSearchFieldValue.bind(this);
        this.searchButtonClickHandle = this.searchButtonClickHandle.bind(this);
        this.dateUpdate = this.dateUpdate.bind(this);
    }

    componentWillMount() {
        const newState = { ...this.state };
        const pageData = this.props.data.trim();
        const pageFilterData = this.props.filterData.trim();

        // check for JSON data on the page,
        // If it exists then we're getting data from local mock json file
        if (pageData && pageData.length) {
            // convert the page contents to JSON format & set to state
            const jsonPageData = $.parseJSON(pageData);
            this.setData(jsonPageData, newState).then(response => {
                this.setState(...this.state, response);
            });
            const jsonPageFilterData = $.parseJSON(pageFilterData);
            this.setData(jsonPageFilterData, newState).then(response => {
                this.setState(...this.state, response);
            });
            // update the app state with new preset filter values
            this.setState(...this.state, newState);
        }
        if (pageFilterData && pageFilterData.length) {
            const jsonPageFilterData = $.parseJSON(pageFilterData);
            this.setData(jsonPageFilterData, newState).then(response => {
                this.setState(...this.state, response);
            });

            // update the app state with new preset filter values
            this.setState(...this.state, newState);
        }
    }

    componentDidMount() {
        clearInterval(this.interval);

        // Always load filters first
        if (this.state.isLoading) {
            this.fetchFilters().then(() => {
                // After filters are loaded, handle edocketID auto-search
                if (this.state.edocketID) {
                    // Set the search field value to show the edocketID being searched
                    this.setState({ searchFieldValue: `e${this.state.edocketID}` });
                    // Open modal if not already shown
                    if (!this.state.showModal) {
                        this.handleOpenModal(this.state.edocketID, 'edocket', '', this.state.clientType);
                    }
                    // Auto-trigger search for the edocketID
                    this.fetchDataByNo(`e${this.state.edocketID}`);
                } else {
                    // Normal data loading
                    this.fetchItems(this.state);
                }
            });
        }
    }

    componentWillUpdate(newProps, newState) {
        const queryParams = buildQueryString(newState);

        this.history.replace({
            pathname: window.location.pathname,
            search: queryParams,
            hash: window.location.hash
        });

        if (newState.currentPage !== this.state.currentPage) {
            scrollTo(document.body, 0, 200);
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    getInitialStateFromProps() {
        const urlParams = new URLSearchParams(window.location.search);
        const edocketId = this.props.edocketID;
        // this one is for testing purposes only
        // const edocketId = urlParams.get('eDocketID');

        if (edocketId) {
            const clientType = urlParams.get('clientType') || 'Destination';

            return {
                edocketID: edocketId,
                modalEdocket: edocketId,
                modalType: 'edocket',
                modalMessage: '',
                clientType,
                showModal: true
            };
        }
        return {};
    }

    setData(data, newState = this.state) {
        return new Promise(resolve => {
            // NOTE! The logic here assumes the data from API is in chronological order
            // set filters if they exist
            // handle blank results
            // if filers and contentdata exist stop loading
            newState.isLoading = false;
            newState.isDataLoading = false;

            if (data.filterOptions && data.filterOptions.length) {
                newState.data.filterOptions = data.filterOptions;
                newState.activeFilters = initActiveFilters(data.filterOptions);
            } else if (data.resources && data.resources.length) {
                newState.data.resources = data.resources;
            } else if (data) {
                // set results & settings - ensure contentData is always an array
                newState.data.contentData = Array.isArray(data) ? data : [];
                if (!newState.activeFilters.length) {
                    newState.activeFilters = initActiveFilters(this.state.data.filterOptions);
                }
            } else {
                newState.data.contentData = [];
                newState.isLoading = false;
                newState.isDataLoading = false;
            }

            resolve(newState);
        });
    }

    getAbortController() {
        if (typeof AbortController === 'function') {
            return new AbortController();
        }

        return {
            signal: null,
            abort: () => {}
        };
    }

    getKeywordFilter(filters) {
        return filters.find(f => f.type === FilterTypeConstants.FILTER_TYPE_KEYWORDS);
    }

    csvLink = React.createRef();

    fetchData(dateOne, dateTwo, invisible = false, foremanID = false, statusID = null, resetFilters = false, callback = null) {
        const newState = { ...this.state };

        if (!invisible) {
            this.setState({ isDataLoading: true });
        }

        // const activeFilters = getActiveFiltersWithValues(newState.activeFilters);
        // return null;
        return new Promise(((resolve, reject) => {
            // For testing use a date we know has data, should be todays date
            // const new Date(2019, 0, 14) 14 jan 2019
            const startDate = dateOne ? dateOne : new Date();
            const endDate = dateTwo ? dateTwo : new Date();

            const startDateString = dateToString(startDate);
            const endDateString = dateToString(endDate);
            newState.edocketID = '';
            newState.startDate = startDate;
            newState.endDate = endDate;
            newState.startDateString = startDateString;
            newState.endDateString = endDateString;

            const ForemanID = foremanID ? foremanID : 0;
            const StatusID = statusID ? statusID : 0;
            newState.unactionedList = !!foremanID;

            const dataObj = {
                method: 'POST',
                headers: {
                    Authorization: this.props.bearerToken,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Origin: ''
                },
                body: JSON.stringify({
                    refId: this.props.refID,
                    DateFrom: startDateString,
                    DateTo: endDateString,
                    ForemanID,
                    StatusID
                })
            };

            const refParam = `RefType=${this.props.refType}`;
            this.fetchDataWithTimeout(`${this.props.dataURL}/api/DraftDocketList?${refParam}`, dataObj)
                .then(data => {
                    this.setData(data, newState).then(response => {
                        if (!resetFilters) {
                            response.activeFilters = this.state.activeFilters;
                        }
                        this.setState(oldState => {
                            return {
                                ...oldState,
                                ...response,
                                isFilterDirty: false,
                                isDateDirty: false,
                                lastStartDate: startDate,
                                lastEndDate: endDate
                            };
                        });
                        this.fetchUnactionedDocketCount();
                        if (callback) {
                            setTimeout(callback, 100);
                        }
                        resolve(data);
                    });
                })
                .catch(error => {
                    this.setData([]).then(response => {
                        this.setState(...this.state, response);
                        reject(error);
                    });
                });
        })).catch(e => {
            this.handleFetchingError(e.message);
        });
    }

    handleFetchingError(errorMessage) {
        this.handleOpenModal(null, 'error', errorMessage);
    }

    fetchDataWithTimeout(dataUrl, dataObj) {
        const { requestTimeoutMs, requestTimeoutError, dataLoadingError } = this.props;
        if (this.controller) {
            this.controller.abort();
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.controller = this.getAbortController();
        if (this.controller.signal) {
            dataObj.signal = this.controller.signal;
        }
        return new Promise((onFulfill, onReject) => {
            this.timeout = setTimeout(() => {
                this.controller.abort();
                return onReject(new Error(requestTimeoutError));
            }, requestTimeoutMs);

            fetch(dataUrl, dataObj)
                .then(response => {
                    clearTimeout(this.timeout);
                    if (response.ok) {
                        onFulfill(response.json());
                    } else {
                        response.json().then(message => {
                            if (message.Message) {
                                const errMsg = message.Message.split(':');
                                if (errMsg[1]) {
                                    onReject(new Error(errMsg[1]));
                                } else {
                                    onReject(new Error(errMsg));
                                }
                            } else {
                                onReject(new Error(dataLoadingError));
                            }
                        });
                    }
                })
                .catch(() => {
                    clearTimeout(this.timeout);
                });
        });
    }

    fetchFilters() {
        const newState = { ...this.state };

        return new Promise((resolve => {
            const dataObj = {
                method: 'GET',
                headers: {
                    Authorization: this.props.bearerToken,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Origin: ''
                }
            };

            const refParam = `RefType=${this.props.refType}`;
            postData(`${this.props.dataURL}/api/ReactFilters?refId=${this.props.refID}&${refParam}&filterName=eDocketSheet`)
                .then(data => {
                    this.setData(data, newState).then(response => {
                        this.prePopulateFilters(response);
                        this.setState(...this.state, response);
                        resolve(data);
                    });
                });

            function postData(dataUrl = '') {
                return fetch(dataUrl, dataObj)
                    .then(response => response.json());
            }
        }));
    }

    fetchDataByNo(eDocketNo, callback = null) {
        if (!eDocketNo) {
            this.fetchData();
            return;
        }
        clearInterval(this.interval);
        const newState = { ...this.state };
        newState.edocketID = eDocketNo;
        this.setState({ isLoading: true });
        const dataObj = {
            method: 'POST',
            headers: {
                Authorization: this.props.bearerToken,
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Origin: ''
            },
            body: JSON.stringify({
                refId: this.props.refID,
                eDocketNo_JobNumber: eDocketNo
            })
        };

        const refParam = `RefType=${this.props.refType}`;
        postData(`${this.props.dataURL}/api/DraftDocketList?abc=456&${refParam}`)
            .then(data => {
                // Preserve existing filterOptions when setting search results
                const currentFilterOptions = this.state.data.filterOptions;
                this.setData(data, newState).then(response => {
                    // Ensure filterOptions are preserved
                    if (currentFilterOptions && currentFilterOptions.length > 0) {
                        response.data.filterOptions = currentFilterOptions;
                    }
                    this.setState({
                        ...this.state,
                        ...response,
                        isFilterDirty: false,
                        isDateDirty: false
                    });
                    if (callback) {
                        setTimeout(callback, 100);
                    }
                });
            });

        function postData(dataUrl = '') {
            return fetch(dataUrl, dataObj)
                .then(response => response.json());
        }
    }

    fetchUnactionedDocketCount() {
        const dataObj = {
            method: 'GET',
            headers: {
                Authorization: this.props.bearerToken,
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Origin: ''
            }
        };

        const refParam = `RefType=${this.props.refType}`;
        postData(`${this.props.dataURL}/api/ForemanUnactionedDocketsCount?refId=${this.props.refID}&${refParam}`)
            .then(data => {
                this.setState({
                    unactionedDocketCount: data.UnactionedDocketCount,
                    unactionedFilterModel: data.UnactionedFilterModel
                });
            });

        function postData(dataUrl = '') {
            return fetch(dataUrl, dataObj)
                .then(response => response.json());
        }
    }

    clearUnactionedDockets() {
        this.fetchData(null, null, false, null, null, true);
    }

    triggerFetchData() {
        if (this.state.unactionedList) {
            this.fetchData(
                new Date(this.state.unactionedFilterModel.DateFrom),
                new Date(this.state.unactionedFilterModel.DateTo),
                true,
                this.state.unactionedFilterModel.ForemanID,
                this.state.unactionedFilterModel.StatusID
            );
        } else {
            this.fetchData(this.state.startDate, this.state.endDate, true);
        }
    }

    recallItems() {
        this.interval = setInterval(() => {
            this.triggerFetchData();
        }, this.props.dataFrequency);
    }

    resetFilters() {
        if (this.state.edocketID) {
            this.fetchData();
        }
        this.setState({
            activeFilters: initActiveFilters(this.state.data.filterOptions),
            currentPage: 0
        });
        const reset = { code: 'reset' };
        this.toggleFocus(reset);
    }

    resetFilterGroup(groupCode) {
        this.setState({
            activeFilters: removeActiveFilterGroup(this.state.activeFilters, groupCode),
            currentPage: 0
        });
        const reset = { code: 'reset' };
        this.toggleFocus(reset);
    }

    toggleFilters(evt, filter, value, forceClear = false, callback = null) {
        this.setState({
            activeFilters: manageActiveFilters(this.state.activeFilters, filter.code, value, forceClear),
            currentPage: 0
        });
        if (callback) {
            setTimeout(callback, 100);
        } else {
            this.toggleFocus(filter);
        }
    }

    updateSearchFieldValue(value) {
        this.setState(oldState => {
            return {
                ...oldState,
                searchFieldValue: value,
                isFilterDirty: true
            };
        });
    }

    searchButtonClickHandle(callback = null) {
        const { searchFieldValue } = this.state;
        const querySearchFieldValue = searchFieldValue;

        let searchByeDocket = false;
        let searchByJob = false;
        // if the search field value starts with any of the character in this array, trigger the eDocket search
        const eDocketCharacters = ['e', 'q', 'p', 'E', 'Q', 'P'];
        if (querySearchFieldValue && querySearchFieldValue !== '') {
            const searcheDocket = eDocketCharacters.includes(querySearchFieldValue.substring(0, 1));
            if (searcheDocket) {
                searchByeDocket = true;
            } else {
                searchByJob = true;
            }
            setTimeout(() => {
                this.setState(oldState => {
                    return {
                        ...oldState,
                        searchFieldValue: querySearchFieldValue
                    };
                });
            }, 10);
        }

        const { filterOptions } = this.state.data;
        const jobFilter = this.getKeywordFilter(filterOptions);

        if (searchByeDocket) {
            this.toggleFilters(null, jobFilter, '', true);
            setTimeout(() => {
                this.fetchDataByNo(querySearchFieldValue, callback);
            }, 10);
        } else if (searchByJob) {
            this.toggleFilters(null, jobFilter, querySearchFieldValue, callback);
        } else {
            const startDate = this.state.startDate
                ? new Date(this.state.startDate)
                : new Date();
            const endDate = this.state.endDate ? new Date(this.state.endDate) : new Date();
            this.toggleFilters(null, jobFilter, '', true);
            this.changePage(0);
            setTimeout(() => {
                this.fetchData(startDate, endDate, false, false, null, false, callback);
            }, 10);
        }
    }

    sameDate(date1, date2) {
        if (date1 && date2) {
            const d1 = date1.getDate();
            const m1 = date1.getMonth();
            const y1 = date1.getFullYear();
            const d2 = date2.getDate();
            const m2 = date2.getMonth();
            const y2 = date2.getFullYear();

            return (d1 === d2) && (m1 === m2) && (y1 === y2);
        }

        return false;
    }

    printDate(date1) {
        if (date1) {
            const d1 = date1.getDate();
            const m1 = date1.getMonth();
            const y1 = date1.getFullYear();

            return `${d1}-${m1}-${y1}`;
        }

        return '-';
    }

    dateUpdate(type, date) {
        if (type === 'start') {
            const currentStartDate = this.state.lastStartDate;
            this.setState({ startDate: date, isDateDirty: !this.sameDate(date, currentStartDate) });
        } else if (type === 'end') {
            const currentEndDate = this.state.lastEndDate;
            this.setState({ endDate: date, isDateDirty: !this.sameDate(date, currentEndDate) });
        }
    }

    changePage(pageNum) {
        this.setState({ currentPage: pageNum });
    }

    updateSort(sort) {
        this.setState({
            currentSort: sort,
            currentPage: 0
        });
    }

    toggleFocus(filterToFocus) {
        this.setState({ focusedFilter: filterToFocus ? filterToFocus.code : null });
    }

    fetchItems() {
        this.fetchData();
        this.recallItems();
    }

    prePopulateFilters(newState) {
        const url = getQueryParams();
        const activeFilters = newState.activeFilters.length ?
            newState.activeFilters :
            initActiveFilters(newState.data.filterOptions);
        const presetFilters = parseQueryString(url, activeFilters, newState.currentPage);
        if (presetFilters) {
            if (JSON.stringify(presetFilters.activeFilters) !== JSON.stringify(newState.activeFilters)) {
                newState.activeFilters = presetFilters.activeFilters;
            }

            if (presetFilters.currentSort !== newState.currentSort) {
                newState.currentSort = presetFilters.currentSort;
            }

            if (parseInt(presetFilters.currentPage, 10) !== 0) {
                newState.currentPage = parseInt(presetFilters.currentPage, 10);
            }
        }
    }

    refreshData() {
        if (this.state.edocketID) {
            this.fetchDataByNo(this.state.edocketID);
        }
        if (this.state.unactionedList) {
            this.fetchData(
                new Date(this.state.unactionedFilterModel.DateFrom),
                new Date(this.state.unactionedFilterModel.DateTo),
                true,
                this.state.unactionedFilterModel.ForemanID,
                this.state.unactionedFilterModel.StatusID
            );
        } else {
            this.fetchData(this.state.startDate, this.state.endDate, true);
        }
    }

    handleCloseModal(refresh = false) {
        const { modalContentDirty } = this.state;
        if (modalContentDirty) {
            // show confirmation
            this.setState({ showModalCloseConfirmation: true });
        } else {
            // Clear URL parameters when modal closes
            const currentSearch = new URLSearchParams(window.location.search);
            currentSearch.delete('eDocketId');
            // currentSearch.delete('refId');
            currentSearch.delete('clientType');

            this.history.replace({
                pathname: window.location.pathname,
                search: currentSearch.toString() ? `?${currentSearch.toString()}` : '',
                hash: undefined
            });

            this.setState({
                showModal: false,
                modalDataItems: null,
                showModalCloseConfirmation: false
            }, () => { if (refresh) { this.refreshData(); } });
        }
    }

    handleOpenModal(modalEdocket, type, message = '', clientType = '', draftDocketLink = '') {
        const { refType } = this.props;

        if (refType.toLowerCase() === 'client') {
            this.setState({
                showModal: true,
                modalType: type,
                modalMessage: message,
                modalEdocket,
                clientType
            });

            // Update browser history with refID, eDocketID and clientType parameters
            if (modalEdocket) {
                const currentSearch = new URLSearchParams(window.location.search);
                currentSearch.set('eDocketId', modalEdocket);
                currentSearch.set('clientType', clientType);

                this.history.replace({
                    pathname: window.location.pathname,
                    search: `?${currentSearch.toString()}`,
                    hash: window.location.hash
                });
            }
        } else if (refType.toLowerCase() === 'contractor' && draftDocketLink !== '') {
            window.open(draftDocketLink, '_blank').focus();
        }
    }

    handleExport() {
        const { isFilterDirty, isDateDirty } = this.state;
        if (isFilterDirty || isDateDirty) {
            // fetch then do export as callback
            this.searchButtonClickHandle(this.doExport);
        } else {
            // just do export
            this.doExport();
        }
    }

    doExport() {
        const activeFilters = getActiveFiltersWithValues(this.state.activeFilters);
        const { contentData } = this.state.data;
        const filterSettingsObj = {
            activeFiltersStyle: 'btn-tags',
            showActiveFilters: this.props.showActiveFilters,
            activeFiltersLabel: this.props.activeFiltersLabel,
            keywordPlaceholderText: this.props.keywordPlaceholderText,
            keywordSearchableFields: this.props.keywordSearchableFields
        };
        const filteredItems = filterItems(activeFilters, contentData, filterSettingsObj.keywordSearchableFields);
        const sortedItems = sortItems(filteredItems, this.state.currentSort);

        if (sortedItems.length > 0) {
            const { searchFieldValue } = this.state;
            const querySearchFieldValue = searchFieldValue;

            this.setState({ csvData: [] });
            const siteNames = activeFilters && activeFilters.find(item => item.code === 'SiteName');
            const ContractorTradingNames = activeFilters && activeFilters.find(item => item.code === 'SupplierTradingName');
            const DraftDocketStatusNames = activeFilters && activeFilters.find(item => item.code === 'StatusName');
            const SiteForemanNames = activeFilters && activeFilters.find(item => item.code === 'SiteForemanName');
            const MaterialNames = activeFilters && activeFilters.find(item => item.code === 'MaterialType');

            const { refType } = this.props;
            let dataObj = null;

            const requestBodyData = {
                refId: this.props.refID,
                refType: refType || '',
                DateFrom: this.state.startDateString,
                DateTo: this.state.endDateString,
                SiteNames: siteNames ? siteNames.values : [],
                ContractorTradingNames: ContractorTradingNames ? ContractorTradingNames.values : [],
                DraftDocketStatusNames: DraftDocketStatusNames ? DraftDocketStatusNames.values : [],
                SiteForemanNames: SiteForemanNames ? SiteForemanNames.values : [],
                MaterialNames: MaterialNames ? MaterialNames.values : [],
                eDocketNo_JobNumber: querySearchFieldValue ? querySearchFieldValue : null,
                CombineLoads: this.state.exportCombineLoads
            };

            dataObj = {
                method: 'POST',
                headers: {
                    Authorization: this.props.bearerToken,
                    Accept: 'text/csv',
                    'Content-Type': 'application/json',
                    Origin: ''
                },
                body: JSON.stringify(requestBodyData)
            };

            const postData = (dataUrl = '') => fetch(dataUrl, dataObj)
                .then(response => {
                    const contentType = response.headers.get('content-type');
                    if (contentType && contentType.indexOf('application/json') !== -1) {
                        return response.json();
                    }
                    return response.text();
                });

            const refParam = `RefType=${this.props.refType}`;
            postData(`${this.props.dataURL}/api/DraftDocketCSVMultiValueFilter?${refParam}`)
                .then(data => {
                    this.setState({ csvData: data });
                    this.csvLink.current.link.click();
                });
        }
    }

    fetchUnactionedDockets() {
        this.fetchData(
            new Date(this.state.unactionedFilterModel.DateFrom),
            new Date(this.state.unactionedFilterModel.DateTo),
            false,
            this.state.unactionedFilterModel.ForemanID,
            this.state.unactionedFilterModel.StatusID,
            true
        );
        this.resetFilters();
    }

    updateContentDirty(isDirty) {
        const { modalContentDirty } = this.state;
        if (modalContentDirty !== isDirty) {
            this.setState({ modalContentDirty: isDirty });
        }
    }

    closeConfirmationConfirmHandler() {
        this.setState({
            showModal: false,
            modalDataItems: null,
            showModalCloseConfirmation: false,
            modalContentDirty: false
        }, () => { this.refreshData(); });
    }

    closeConfirmationCancelHandler() {
        this.setState({ showModalCloseConfirmation: false });
    }

    toggleExportCombineLoads() {
        this.setState(prevState => {
            return { exportCombineLoads: !prevState.exportCombineLoads };
        });
    }

    renderAPIErrorMessage() {
        if (this.state.APIStatus !== 'error') { return null; }

        return (
            <p className="validation-msg">Oops, something went wrong: {this.state.APIMessage}</p>
        );
    }

    render() {
        if (this.state.isLoading) {
            return (
                <Loader />
            );
        }

        const { showModalCloseConfirmation, exportCombineLoads } = this.state;
        const { contentData, filterOptions, resources } = this.state.data;
        const { filtersLayout, tileContainerColumnClass, tileContainerTilesWrap, tileType } = this.props;
        const filterSettingsObj = {
            activeFiltersStyle: 'btn-tags',
            showActiveFilters: this.props.showActiveFilters,
            activeFiltersLabel: this.props.activeFiltersLabel,
            keywordPlaceholderText: this.props.keywordPlaceholderText,
            keywordSearchableFields: this.props.keywordSearchableFields
        };
        const activeFilters = getActiveFiltersWithValues(this.state.activeFilters);
        const filteredItems = filterItems(activeFilters, contentData, filterSettingsObj.keywordSearchableFields);
        const sortedItems = sortItems(filteredItems, this.state.currentSort);
        const pagedItems = paginateItems(sortedItems, this.state.currentPage, this.props.itemsPerPage);
        const startDate = this.state.startDate ? new Date(this.state.startDate).getTime() : new Date().getTime();
        const endDate = this.state.endDate ? new Date(this.state.endDate).getTime() : new Date().getTime();

        return (
            <div className={`layout-${filtersLayout}`}>
                <CSVLink
                    data={this.state.csvData}
                    filename="edockets-sheet.csv"
                    className="csv-download hidden"
                    ref={this.csvLink}
                    target="_blank"
                >
                Download me
                </CSVLink>
                <FilteredListingHeader
                    title={this.props.headerTitle}
                    subtitle={this.props.headerSubtitle}
                    fetchDataByNo={this.fetchDataByNo}
                    resetFilters={this.resetFilters}
                    startDate={this.state.startDateString}
                    endDate={this.state.endDateString}
                    activeFilters={activeFilters}
                    refID={this.props.refID}
                    itemCount={sortedItems.length}
                    unactionedDocketCount={this.state.unactionedDocketCount}
                    fetchUnactionedDockets={this.fetchUnactionedDockets}
                    unactionedList={this.state.unactionedList}
                    clearUnactionedDockets={this.clearUnactionedDockets}
                    companySelectionPage={this.props.companySelectionPage} // new props
                    logo={this.props.logo}
                    companyName={this.props.companyName}
                />
                <div className="listing-wrapper">
                    <FiltersSection
                        filters={filterOptions || []}
                        filterSettings={filterSettingsObj}
                        activeFilters={activeFilters}
                        toggleFilters={attachEnterAsClickDecorator(this.toggleFilters)}
                        resetFilterGroup={this.resetFilterGroup}
                        resetFilters={this.resetFilters}
                        focusedFilter={this.state.focusedFilter}
                        toggleFocus={this.toggleFocus}
                        minDate={this.state.minDate}
                        maxDate={this.state.maxDate}
                        fetchData={this.fetchData}
                        startDate={startDate}
                        endDate={endDate}
                        dateUpdate={this.dateUpdate} // new props
                        itemCount={sortedItems.length} // new props
                        eDocketSearchPlaceholder={this.props.headerEdocketName} // new props
                        searchFieldValue={this.state.searchFieldValue} // new props
                        searchFieldChange={this.updateSearchFieldValue} // new props
                        searchButtonClick={this.searchButtonClickHandle} // new props
                        exportText={this.props.headerButtonText} // new props
                        exportCombineLoads={exportCombineLoads} // new props
                        exportCombineLoadToggle={this.toggleExportCombineLoads} // new props
                        handleExport={this.handleExport} // new props
                        refType={this.props.refType.toLowerCase()}
                        isLoading={this.state.isDataLoading}
                    />
                    {this.state.isDataLoading ?
                        <Loader /> :
                        <ListingItemsSection
                            listingItems={pagedItems}
                            resources={resources}
                            tileContainerColumnClass={tileContainerColumnClass}
                            tileContainerTilesWrap={tileContainerTilesWrap}
                            tileType={tileType}
                            totalPages={Math.ceil(filteredItems.length / this.props.itemsPerPage)}
                            currentPage={this.state.currentPage}
                            perPage={this.props.itemsPerPage}
                            totalItems={sortedItems.length}
                            changePage={this.changePage}
                            resetFilters={this.resetFilters}
                            handleOpenModal={this.handleOpenModal}
                            refType={this.props.refType}
                        />
                    }
                </div>
                <ReactModal
                    isOpen={this.state.showModal}
                    contentLabel="react-modal"
                    className="react-modal client-portal-modal"
                    overlayClassName="react-overlay"
                    onRequestClose={() => {
                        this.handleCloseModal();
                    }}
                >
                    <div className="prompt-container">
                        <div className="modalData">
                            <ModalHelper
                                modalEdocket={this.state.modalEdocket}
                                modalType={this.state.modalType}
                                modalMessage={this.state.modalMessage}
                                refID={this.props.refID}
                                closeModal={this.handleCloseModal}
                                bearerToken={this.props.bearerToken}
                                dataURL={this.props.dataURL}
                                clientType={this.state.clientType}
                                detailData={this.props.detailData}
                                updateContentDirty={this.updateContentDirty}
                            />
                            {showModalCloseConfirmation &&
                                <ModalCloseConfirmation
                                    message="You have not saved your changes. If you close this page, then your changes will be lost."
                                    confirmTitle="Close"
                                    confirmHandler={this.closeConfirmationConfirmHandler}
                                    cancelTitle="Cancel"
                                    cancelHandler={this.closeConfirmationCancelHandler}
                                />
                            }
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    }
}

FilteredListing.propTypes = {
    data: string,
    filterData: string,
    tileType: string,
    dataFrequency: number,
    tileContainerColumnClass: string,
    tileContainerTilesWrap: string,
    filtersLayout: string,
    itemsPerPage: number,
    showActiveFilters: bool,
    activeFiltersLabel: string,
    keywordPlaceholderText: string,
    keywordSearchableFields: arrayOf(string),
    headerTitle: string,
    headerSubtitle: string,
    headerButtonText: string,
    headerEdocketName: string,
    refID: oneOfType([string, number]),
    edocketID: oneOfType([string, number]),
    bearerToken: string,
    dataURL: string,
    requestTimeoutMs: number,
    requestTimeoutError: string,
    dataLoadingError: string,
    detailData: string,
    companySelectionPage: string,
    logo: string,
    companyName: string,
    refType: string
};

FilteredListing.defaultProps = {
    data: '',
    filterData: '',
    tileType: 'base-tile',
    dataFrequency: 600000,
    tileContainerColumnClass: 'col-four',
    tileContainerTilesWrap: 'tiles-wrap',
    filtersLayout: 'filters-top',
    itemsPerPage: '20',
    showActiveFilters: false,
    activeFiltersLabel: 'Active Filters',
    keywordPlaceholderText: '',
    keywordSearchableFields: ['jobID'],
    headerTitle: 'data-title',
    headerSubtitle: 'data-subtitle',
    headerButtonText: 'data-export-button-text',
    headerEdocketName: 'data-edocket-name',
    refID: '',
    edocketID: '',
    bearerToken: '',
    dataURL: '/',
    requestTimeoutMs: 40000,
    requestTimeoutError: 'Data loading took too much time. Please adjust filters to reduce the results count.',
    dataLoadingError: 'There has been an error during loading of the results.',
    detailData: '',
    companySelectionPage: '',
    logo: '',
    companyName: '',
    refType: 'client'
};
